import Model from '@/models/Model'

export default class GUserSeller extends Model {
    static includes = ['hr_employee.g_branch_office']
    static appends = ['customers', 'is_ground_seller', 'commissions']

    resource() {
        return 'g_user_seller'
    }

    get rutUser() {
        try {
            let { rut } = this.hr_employee
            if (this.hr_employee !== null) return rut
            else return ''
        } catch (e) {
            return `error ${e}`
        }
    }

    get userFullName() {
        try {
            let { names, last_name1, last_name2 } = this.hr_employee
            if (this.hr_employee !== null)
                return [names, last_name1, last_name2].join(' ')
            else return ''
        } catch (e) {
            return `error ${e}`
        }
    }

    get commissionsUser() {
        try {
            let { commissions } = this
            if (commissions.length > 0)
                return commissions.map(({ name }) => name).join(', ')
            else return 'Sin Comisión'
        } catch (e) {
            return `error ${e}`
        }
    }

    get userIsGroundSeller() {
        try {
            let { is_ground_seller } = this
            return is_ground_seller ? true : false
        } catch (e) {
            return `error ${e}`
        }
    }

    get customersUser() {
        try {
            let { customers } = this
            if (customers.length > 0) return customers.length
            else return 'Sin Clientes'
        } catch (e) {
            return `error ${e}`
        }
    }
}
